"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.array.find-index");
var _commonMenuTemplateManage = _interopRequireDefault(require("./commonMenuTemplateManage.vue"));
var _timeMenuTemplateManage = _interopRequireDefault(require("./timeMenuTemplateManage.vue"));
var _groupDinnerTemplateManage = _interopRequireDefault(require("./groupDinnerTemplateManage.vue"));
var _detail = _interopRequireDefault(require("./detail.vue"));
var _groupSort = _interopRequireDefault(require("./groupSort.vue"));
var _menuTemplate = require("@/api/goods/menuTemplate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '菜单模版',
  components: {
    commonMenuTemplateManage: _commonMenuTemplateManage.default,
    timeMenuTemplateManage: _timeMenuTemplateManage.default,
    groupDinnerTemplateManage: _groupDinnerTemplateManage.default,
    detail: _detail.default,
    groupSort: _groupSort.default
  },
  data: function data() {
    return {
      activeTab: 'commonManage',
      panes: [{
        label: '普通模版',
        name: 'commonManage'
      }, {
        label: '分时模版',
        name: 'timeManage'
      }, {
        label: '团餐模版',
        name: 'groupDinnerManage'
      }]
    };
  },
  watch: {
    activeTab: function activeTab(newVal) {
      var _this = this;
      // 使用 setTimeout 确保组件已经挂载，增加到 300ms
      setTimeout(function () {
        if (newVal === 'commonManage' && _this.$refs.commonMenuTemplateManage) {
          var ref = _this.$refs.commonMenuTemplateManage;
          if (Array.isArray(ref) && ref[0]) {
            ref[0].getList();
          } else if (ref) {
            ref.getList();
          }
        } else if (newVal === 'timeManage' && _this.$refs.timeMenuTemplateManage) {
          var _ref = _this.$refs.timeMenuTemplateManage;
          if (Array.isArray(_ref) && _ref[0]) {
            _ref[0].getList();
          } else if (_ref) {
            _ref.getList();
          }
        } else if (newVal === 'groupDinnerManage' && _this.$refs.groupDinnerTemplateManage) {
          var _ref2 = _this.$refs.groupDinnerTemplateManage;
          if (Array.isArray(_ref2) && _ref2[0]) {
            _ref2[0].getList();
          } else if (_ref2) {
            _ref2.getList();
          }
        }
      }, 300);
    }
  },
  methods: {
    handleTabRemove: function handleTabRemove(name) {
      if (name === 'groupDinnerManage') return;
      var idx = this.panes.findIndex(function (p) {
        return p.name === name;
      });
      if (idx !== -1) {
        this.panes.splice(idx, 1);
        // 若关闭的是当前活动 Tab，自动切回管理 Tab
        if (this.activeTab === name) {
          this.activeTab = 'groupDinnerManage';
        }
      }
    },
    handleEditTemplate: function handleEditTemplate(templateId) {
      var _this2 = this;
      var name = "detail-".concat(templateId);
      var exists = this.panes.find(function (p) {
        return p.name === name;
      });
      if (!exists) {
        // 先占位，再异步获取名称
        this.panes.push({
          label: '模板详情',
          name: name,
          templateId: templateId
        });
        (0, _menuTemplate.getById)(templateId).then(function (res) {
          var tplName = res && res.data && res.data.name ? res.data.name : '模板';
          var pane = _this2.panes.find(function (p) {
            return p.name === name;
          });
          if (pane) pane.label = "".concat(tplName, "-\u8BE6\u60C5");
        }).catch(function () {});
      }
      this.activeTab = name;
    },
    handleGroupSort: function handleGroupSort(templateId, templateName) {
      var name = "groupSort-".concat(templateId);
      var exists = this.panes.find(function (p) {
        return p.name === name;
      });
      if (!exists) {
        this.panes.push({
          label: "".concat(templateName, "-\u5206\u7EC4\u6392\u5E8F"),
          name: name,
          templateId: templateId,
          templateName: templateName,
          type: 'groupSort'
        });
      }
      this.activeTab = name;
    }
  }
};